import { z } from "zod";
import { getWebsiteDeliveryVerticalContract } from "./vertical-contract.js";
export const WebsiteDeliveryContractDocumentV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.website-delivery-contract.v1.0"),
    contractDocumentId: z.string().regex(/^wdcn_[a-zA-Z0-9_-]+$/),
    templateVersion: z.string().min(1),
    clauseIds: z.array(z.string().min(1)).min(1),
    legalReviewRequired: z.boolean(),
    legalReviewCompleted: z.boolean(),
    status: z.enum(["DRAFT", "LEGAL_HOLD", "READY_FOR_SIGNATURE"]),
    createdAt: z.string().datetime(),
})
    .strict();
export function enforceWebsiteDeliveryContractClauses(input) {
    const contract = getWebsiteDeliveryVerticalContract();
    const known = new Set(contract.clauses.map((c) => c.clauseId));
    for (const id of input.clauseIds) {
        if (!known.has(id)) {
            throw new Error(`unknown_clause:${id}`);
        }
    }
    const requiresLegal = input.clauseIds.some((id) => {
        const clause = contract.clauses.find((c) => c.clauseId === id);
        return clause?.requiresLegalReview === true;
    });
    if (requiresLegal && !input.legalReviewCompleted) {
        return WebsiteDeliveryContractDocumentV1Schema.parse({
            schemaVersion: "clientops.website-delivery-contract.v1.0",
            contractDocumentId: input.contractDocumentId,
            templateVersion: input.templateVersion,
            clauseIds: input.clauseIds,
            legalReviewRequired: true,
            legalReviewCompleted: false,
            status: "LEGAL_HOLD",
            createdAt: input.now ?? new Date().toISOString(),
        });
    }
    return WebsiteDeliveryContractDocumentV1Schema.parse({
        schemaVersion: "clientops.website-delivery-contract.v1.0",
        contractDocumentId: input.contractDocumentId,
        templateVersion: input.templateVersion,
        clauseIds: input.clauseIds,
        legalReviewRequired: requiresLegal,
        legalReviewCompleted: input.legalReviewCompleted,
        status: "READY_FOR_SIGNATURE",
        createdAt: input.now ?? new Date().toISOString(),
    });
}
//# sourceMappingURL=contract-templates.js.map